module.exports = __webpack_public_path__ + "site/img/116.a8b12acd.jpg";